import React, { useState } from 'react';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
import { regions } from '../../data/regions';
export function RegionalAgenda() {
  const [activeId, setActiveId] = useState(regions[0].id);
  const active = regions.find(region => region.id === activeId) ?? regions[0];
  return <section aria-labelledby="regional-heading" className="bg-sand-50 py-16 sm:py-20 lg:py-28" data-id="element-274" data-mp="xslt7jqbbqg1">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-275" data-mp="12qnbi2fwzlqg">
        <SectionHeading eyebrow="Regional agenda" title="What this plan means where you live" intro="Six geopolitical zones, 36 states and the FCT — each with its own priorities under the national agenda." data-id="element-276" data-mp="12ou3ojtkevgv" />

        <div className="mt-12 grid gap-6 lg:grid-cols-12" data-id="element-277" data-mp="f0j9u0madw23">
          <div className="lg:col-span-4" data-id="element-278" data-mp="k0p6jv7ey8r1">
            <label htmlFor="region-select" className="sr-only" data-id="element-279" data-mp="jznjsth1bxth">
              Select a region
            </label>
            <select id="region-select" value={activeId} onChange={event => setActiveId(event.target.value)} className="w-full rounded-lg border border-sand-300 bg-white px-4 py-3 text-[15px] text-ink lg:hidden" data-id="element-280" data-mp="1f3woclphplp4">
              {regions.map(region => <option key={region.id} value={region.id} data-id="element-281" data-mp="10dgzmwxv7vm7">
                  {region.name}
                </option>)}
            </select>

            <ul className="hidden lg:block" role="tablist" aria-label="Geopolitical zones" data-id="element-282" data-mp="rdtz0dcymtu7">
              {regions.map(region => {
              const isActive = region.id === activeId;
              return <li key={region.id} data-id="element-283" data-mp="hi8r5yl7mzcj">
                    <button type="button" role="tab" aria-selected={isActive} aria-controls="region-panel" onClick={() => setActiveId(region.id)} className={`flex w-full items-center justify-between border-l-2 py-4 pl-5 pr-3 text-left transition-colors duration-150 ease-emphasis ${isActive ? 'border-green-600 bg-white' : 'border-sand-300 hover:border-green-400 hover:bg-white/60'}`} data-id="element-284" data-mp="2gttd88vfr9gp">
                      <span className={`font-display text-[19px] ${isActive ? 'text-ink' : 'text-slate-600'}`} data-id="element-285" data-mp="sx2ez7feo3wd">
                        {region.name}
                      </span>
                      <span className="text-[12px] font-semibold text-slate-500" data-id="element-286" data-mp="nwemehbj3f01">
                        {region.states.length} states
                      </span>
                    </button>
                  </li>;
            })}
            </ul>
          </div>

          <div id="region-panel" role="tabpanel" aria-label={`${active.name} agenda`} className="rounded-media border border-sand-200 bg-white p-7 shadow-card lg:col-span-8 lg:p-10" data-id="element-287" data-mp="313noh98z0b83">
            <p className="flex items-center gap-2 text-[13px] font-semibold text-green-700" data-id="element-288" data-mp="3b0sbtcejycqh">
              <MapPinIcon aria-hidden className="h-4 w-4" data-id="element-289" data-mp="363s83856dm2j" />
              {active.name}
            </p>
            <h3 className="mt-3 max-w-[22ch] font-display text-[26px] leading-tight text-ink sm:text-[32px]" data-id="element-290" data-mp="2ie7n6jpgoeqm">
              {active.headline}
            </h3>
            <p className="mt-4 max-w-2xl text-[16px] leading-relaxed text-slate-600" data-id="element-291" data-mp="2s2zbmhvbcgws">
              {active.detail}
            </p>

            <div className="mt-8 grid gap-8 sm:grid-cols-2" data-id="element-292" data-mp="2nb7v705vfrkd">
              <div data-id="element-293" data-mp="1zmokyf39h4pn">
                <h4 className="text-[12px] font-bold uppercase tracking-[0.12em] text-slate-500" data-id="element-294" data-mp="1zm512su1w68z">
                  Priority commitments
                </h4>
                <ul className="mt-3 space-y-2" data-id="element-295" data-mp="1ulhd6g14c5iz">
                  {active.priorities.map(priority => <li key={priority} className="flex items-start gap-2.5 text-[15px] text-slate-700" data-id="element-296" data-mp="xudno8f0xtth">
                      <span aria-hidden className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold-500" data-id="element-297" data-mp="16vbueygukffr" />
                      {priority}
                    </li>)}
                </ul>
              </div>
              <div data-id="element-298" data-mp="1lkg9i6sci3jn">
                <h4 className="text-[12px] font-bold uppercase tracking-[0.12em] text-slate-500" data-id="element-299" data-mp="1ljy9r06h576z">
                  States covered
                </h4>
                <ul className="mt-3 flex flex-wrap gap-2" data-id="element-300" data-mp="1umpkexrizyxk">
                  {active.states.map(state => <li key={state} className="rounded border border-sand-300 bg-sand-50 px-2.5 py-1 text-[13px] text-slate-600" data-id="element-301" data-mp="3rfsrf4gdws4b">
                      {state}
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="mt-9 border-t border-sand-200 pt-6" data-id="element-302" data-mp="3k2a0er2qp2x4">
              <Button data-id="element-303" data-mp="3f5jmoaeeqjev">
                Explore the {active.name} agenda
                <ArrowRightIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-304" data-mp="3a5oxcbaa61vx" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}